import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this.selectedLevelOneId = null
        this.selectedLevelTwoId = null

        const showLevelOne = this.element.dataset.showLevelOne === 'true'
        if (!showLevelOne) {
            this.loadLevelTwos()
        }
    }

    loadLevelTwos(levelOneId = null) {
        const url = levelOneId
            ? `/level_hierarchy/level_twos?level_one_id=${levelOneId}`
            : `/level_hierarchy/level_twos`

        fetch(url)
            .then(res => res.json())
            .then(data => this.renderLevelTwoTable(data))
    }

    levelOneClick(event) {
        event.preventDefault()
        const id = event.currentTarget.dataset.levelOneId
        this.selectedLevelOneId = id

        document.querySelectorAll('[data-level-one-id]').forEach(el => {
            el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
        })
        event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

        this.selectedLevelTwoId = null
        this.deleteTarget = 'level_one'

        document.querySelector('#newBtn').classList.remove('d-none')
        document.querySelector('#newBtn').href = `/level_twos/new?level_one_id=${id}`
        document.querySelector('#editBtn').classList.remove('d-none')
        document.querySelector('#editBtn').href = `/level_ones/${id}/edit`
        document.querySelector('#deleteBtn').classList.remove('d-none')
        document.querySelector('#deleteForm').action = `/level_ones/${id}`

        this.loadLevelTwos(id)
    }

    renderLevelTwoTable(data) {
        const tbody = document.querySelector('#levelTwoTable tbody')
        tbody.innerHTML = ''

        if (data.length === 0) {
            tbody.classList.remove('border-bottom')
            tbody.innerHTML = '<tr><td colspan="2" class="text-center text-muted py-5">該当データはありません。</td></tr>'
            return
        }
        tbody.classList.add('border-bottom')
        data.forEach(item => {
            tbody.innerHTML += `
            <tr class="cursor-pointer" data-level-two-id="${item.id}" data-action="click->level-hierarchy#levelTwoClick">
                <td class="fs-6 p-4">
                <span class="text-primary-two fs-5 fw-bold d-block">${item.level_two_code}</span>
                <span class="truncate-text">${item.name}</span>
                </td>
            </tr>
            `
        })
    }

    levelTwoClick(event) {
        event.preventDefault()
        const id = event.currentTarget.dataset.levelTwoId

        document.querySelectorAll('[data-level-two-id]').forEach(el => {
            el.closest('tr').classList.remove('bg-opacity-25', 'bg-primary')
        })
        event.currentTarget.closest('tr').classList.add('bg-opacity-25', 'bg-primary')

        this.selectedLevelTwoId = id
        this.deleteTarget = 'level_two'

        document.querySelector('#newBtn').classList.add('d-none')
        document.querySelector('#editBtn').classList.remove('d-none')
        document.querySelector('#editBtn').href = `/level_twos/${id}/edit`
        document.querySelector('#deleteBtn').classList.remove('d-none')
        document.querySelector('#deleteForm').action = `/level_twos/${id}`
    }
}